export default __webpack_public_path__ + "static/media/desktops.ea53c962.jpg";